import * as React from "react";
import gritLogo from "src/assets/grit-leadership-logo-black.svg";
import coachAcademyLogo from "src/assets/CoachesAcademy.png";
export default function EmbedHeader() {

  const baseUrl = "https://gritleadershipea.com/";
  const coachAcademyUrl = "https://champions101.lightspeedvt.com/";

  return (
    <header className="c101-embed-header">
      <div className="c101-embed-header__brand">
        <a href={coachAcademyUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={coachAcademyLogo}
            alt="Champions 101 Coaches Academy"
            className="c101-embed-header__logo c101-embed-header__logo--partner"
          />
        </a>
      </div>
      <div className="c101-embed-header__brand">
        <a href={baseUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={gritLogo}
            alt="Grit Leadership"
            className="c101-embed-header__logo c101-embed-header__logo--grit"
          />
        </a>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/features/home/pages/embed/components/EmbedHeader.tsx